export default __webpack_public_path__ + "static/media/gold_standard.3ce7787f.svg";